import { css } from '@emotion/react';
import { Box, styled } from '@mui/material';
import type { ReactNode } from 'react';
import { Fragment } from 'react';

import { StyledDivider } from '@/components/common/StyledDivider';
import { DetailSidebarTitle } from '@/components/map/details/DetailSidebarTitle';
import type { MapLayer } from '@/types/MapLayer';

const ScrollContainer = styled(Box)(
  ({ theme }) => css`
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
  `,
);

interface MapDetailsProps {
  title: string;
  subtitle?: string;
  mapLayer: MapLayer;
  children: ReactNode;
}

export function DetailSidebarContent({ title, subtitle, mapLayer, children }: MapDetailsProps) {
  return (
    <Fragment>
      <DetailSidebarTitle mapLayer={mapLayer} subtitle={subtitle} title={title} />

      <StyledDivider sx={{ marginBottom: 4 }} />

      <ScrollContainer>{children}</ScrollContainer>
    </Fragment>
  );
}
